import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
import Link from "next/link";
import { DepthCategorySelector } from "./DepthCategorySelector";
/**
 * CategoryLNB의 헤더 영역 (제목 + depth 카테고리 셀렉터)
 */ export const CategoryLNBHeader = (param)=>{
    let { title , titleHref , depthCategories , currentDepthCategoryId , onDepthCategoryChange  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            titleHref ? /*#__PURE__*/ _jsx(Link, {
                href: titleHref,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    className: "text-strong hover:underline",
                    children: title
                })
            }) : /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                className: "text-strong",
                children: title
            }),
            depthCategories && onDepthCategoryChange && /*#__PURE__*/ _jsx(DepthCategorySelector, {
                categories: depthCategories,
                currentCategoryId: currentDepthCategoryId,
                onCategoryChange: onDepthCategoryChange
            })
        ]
    });
};
